import { render } from "./WealthAdmin.vue?vue&type=template&id=b1e8bad4"
import script from "./WealthAdmin.vue?vue&type=script&lang=js"
export * from "./WealthAdmin.vue?vue&type=script&lang=js"

import "./WealthAdmin.vue?vue&type=style&index=0&id=b1e8bad4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__